import { render, staticRenderFns } from "./PopupScore.vue?vue&type=template&id=d7e2579e&"
import script from "./PopupScore.vue?vue&type=script&lang=js&"
export * from "./PopupScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports